import styled from 'styled-components'

import { earningsBridgePlotHeight } from '@/metrics/pages/PerformanceInsightsPage/GlobalTab/EarningsSection/NetSalesToMarginCard/constants'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
  min-width: 0;
`

export const Track = styled.div`
  display: flex;
  flex-direction: column;
  height: ${earningsBridgePlotHeight}px;
  padding-top: ${props => props.theme.spacing.sp32};
  background-color: ${props => props.theme.colors.background.secondary};
`

export const Plot = styled.div`
  position: relative;
  flex: 1;
`

export const Reference = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  height: ${props => props.barOffset + props.barHeight}%;
  background-color: ${props => props.theme.palette.green.tone100};
`

export const Bar = styled.div`
  position: absolute;
  right: 0;
  bottom: ${props => props.barOffset}%;
  left: 0;
  height: ${props => props.barHeight}%;
  min-height: ${props => props.theme.stroke.emphasis};
  background-color: ${props => (props.isLoss ? props.theme.palette.red.tone800 : props.theme.palette.green.tone800)};
`

export const Amount = styled.div`
  position: absolute;
  bottom: 100%;
  left: 50%;
  padding-bottom: ${props => props.theme.spacing.sp4};
  white-space: nowrap;
  transform: translateX(-50%);
`

export const Placeholder = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  padding-bottom: ${props => props.theme.spacing.sp8};
`

export const Label = styled.div`
  text-align: center;
`
